import {
    GetHealthCampByOrganizationListActionTypes,
    GET_HEALTHCAMP_BY_ORGANIZATION_LIST_FAIL,
    GET_HEALTHCAMP_BY_ORGANIZATION_LIST_LOADING,
    GET_HEALTHCAMP_BY_ORGANIZATION_LIST_SUCCESS,
    GetHealthCampByOrganizationListState,
    GET_HEALTHCAMP_BY_ORGANIZATION_LIST_UPDATE_API_MSG,
    GET_HEALTHCAMP_BY_ORGANIZATION_LIST_UPDATE_API_RES,
  } from "./ActionTypes";
  import { GetHealthCampByOrganizationRes } from "./Model";
  
  const initialStateGetPosts: GetHealthCampByOrganizationListState = {
    loading: false,
    getHealthCampByOrganizationListRes: {} as GetHealthCampByOrganizationRes,
    successMsg: "",
    errorMsg: "",
    status: 0,
  };
  export const getHealthCampByOrganizationListReducer = (
    state = initialStateGetPosts,
    action: GetHealthCampByOrganizationListActionTypes
  ): GetHealthCampByOrganizationListState => {
    switch (action.type) {
      case GET_HEALTHCAMP_BY_ORGANIZATION_LIST_LOADING:
        return {
          ...state,
          loading: action.loading,
        };
      case GET_HEALTHCAMP_BY_ORGANIZATION_LIST_SUCCESS:
        return {
          ...state,
          getHealthCampByOrganizationListRes: action.payload,
          successMsg: action.successMsg,
        };
      case GET_HEALTHCAMP_BY_ORGANIZATION_LIST_FAIL:
        return {
          ...state,
          getHealthCampByOrganizationListRes: action.payload,
          errorMsg: action.errorMsg,
          status: action.status,
        };
      case GET_HEALTHCAMP_BY_ORGANIZATION_LIST_UPDATE_API_MSG:
        return {
          ...state,
          getHealthCampByOrganizationListRes: action.payload,
          successMsg: action.successMsg,
          errorMsg: action.errorMsg,
          status: action.status,
        };
      case GET_HEALTHCAMP_BY_ORGANIZATION_LIST_UPDATE_API_RES:
        return {
          ...state,
          getHealthCampByOrganizationListRes: action.payload,
          successMsg: action.successMsg,
          errorMsg: action.errorMsg,
          status: action.status,
        };
      default:
        return state;
    }
  };
  